import { render } from "./ApplicantEditModal.vue?vue&type=template&id=5a130a96"
import script from "./ApplicantEditModal.vue?vue&type=script&lang=js"
export * from "./ApplicantEditModal.vue?vue&type=script&lang=js"

import "./ApplicantEditModal.vue?vue&type=style&index=0&id=5a130a96&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__